import { createContext, useState, useContext } from "react";

import config from "../config.json";

export const LogContext = createContext();
LogContext.displayName = "LogContext";

export const LogProvider = ({ children }) => {
  const [logSettings, setLogSettings] = useState();

  if (!logSettings) {
    const settings = {
      appMode: config.appMode,
      doLogMessage: config.appMode !== "PROD" ? true : false,
      doLogError: true,
    };

    setLogSettings(settings);
  }

  return (
    <LogContext.Provider value={{ logSettings, setLogSettings }}>
      {children}
    </LogContext.Provider>
  );
};

export const useLogContext = () => {
  const ctx = useContext(LogContext);

  if (!ctx) {
    throw new Error("need provider");
  }

  return ctx;
};
